export default __webpack_public_path__ + "static/media/casque.6f51571e.jpg";